module.exports = __webpack_public_path__ + "24507a602ece5d8fb695c42e76e47992.png";